

if (!Shopify) var Shopify = {};
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        var value = (cents / 100).toFixed(2);
        return '£' + value;
    };
}

var productTagsMap = {};

$('.cart-item').each(function() {
    var itemId = $(this).data('cartitem-id');
    var tags = $(this).data('product-tags');
    productTagsMap[itemId] = tags;
});

$(document).ready(function() {

    $('.cart-drawer-close-button').on('click', function() {
        $('#cart-drawer').removeClass('open');
        $('.cart-drawer-backdrop').hide();
        $('body').removeClass('no-scroll');
    });

    $(document).on('click', function(event) {
        if (!$(event.target).closest('#cart-drawer').length && $('#cart-drawer').hasClass('open')) {
            $('#cart-drawer').removeClass('open');
            $('.cart-drawer-backdrop').hide();
            $('body').removeClass('no-scroll');
        }
    });

 $(document).on('click', '.custom-atc-button', function(event) {
    event.preventDefault();

    if (!$(this).hasClass('disabled')) {
        const form = $(this).closest('form');
        const formData = form.serialize();

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            dataType: 'json',
            success: function() {

                $('#cart-drawer').load(window.location.href + ' #cart-drawer > *', function() {

                    updateCartDrawer();
                    $('.modal-close').click();
                    $('#cart-drawer').addClass('open');
                    $('.cart-drawer-backdrop').show();
                    $('body').addClass('no-scroll');
                });
            },
            error: function() {
                alert("Failed to add item to cart.");
            }
        });
    }
});

  $(document).on("cartItemAdded", function() {
        updateCartDrawer();
    updateHeaderCartCount();
    });

function updateCartDrawer() {
    $.getJSON('/cart.js', function(cart) {
        let currency = cart.currency || 'GBP'; 
        let moneyFormat = window.ShopifyMoneyFormat || '$';

        let fetchPromises = [];

        let itemCount = cart.item_count;
        let viewCartButton = $('.atc-button--viewcart');
        viewCartButton.html('View Cart (' + itemCount + ')');

        var headerCartCountElement = $('.site-header-cart--count');
        headerCartCountElement.attr('data-header-cart-count', itemCount);

        var subtotal = cart.total_price / 100;
        updateDeliveryProgressBar(subtotal);

        let inventoryData = {};
        try {
            let inventoryJson = $('#cart-inventory-data').text();
            inventoryData = JSON.parse(inventoryJson);
        } catch(e) {
            console.error('Failed to parse inventory data:', e);
        }

        cart.items.forEach(function(item) {
            if (!productTagsMap[item.id]) {
                let fetchPromise = $.getJSON('/products/' + item.handle + '.js', function(product) {
                    productTagsMap[item.id] = product.tags;
                });
                fetchPromises.push(fetchPromise);
            }
        });

        Promise.all(fetchPromises).then(() => {
            let drawerContent = '';
            let shouldShowSaltUpsell = false;
            let shouldShowKitUpsell = false;
            let kitCompatibleHandles = [];
            let upsellHtml = '';

            cart.items.forEach(function(item) {
                var tags = productTagsMap[item.id] || '';
                tags = String(tags).toLowerCase();
                let productTags = tags.split(',');

                let maxQuantity = inventoryData[item.variant_id]?.max_quantity || 999999;

                let multiBuyOffers = productTags
                    .filter(tag => tag.includes('multi buy_'))
                    .map(tag => {
                        let parts = tag.split('_')[1].split(' for ');
                        if (parts.length === 2) {
                            let [quantity, price] = parts;
                            return { quantity: parseInt(quantity), price: parseFloat(price.replace('£', '')), tag };
                        } else if (tag.includes('bulk savings')) {
                            return { bulkSavings: true, tag };
                        } else {
                            return {};
                        }
                    });

                multiBuyOffers.sort((a, b) => a.quantity - b.quantity);

                let offerMessageHtml = '';
                let additionalQuantityNeeded = 0;
                if (multiBuyOffers.length > 0) {
                    let offer = multiBuyOffers.find(o => o.bulkSavings || o.quantity);
                    if (offer && offer.bulkSavings) {
                        additionalQuantityNeeded = 2;
                        offerMessageHtml = '<div class="multi-buy-message">' +
                            '<div class="multi-buy-message-inner">This offer is 3 for 20% Off</div>' +
                            '<button class="add-remaining" data-id="' + item.id + '" data-additional-quantity="' + additionalQuantityNeeded + '">+</button>' +
                            '</div>';
                    } else if (offer && offer.quantity) {
                        additionalQuantityNeeded = offer.quantity - item.quantity;
                        if (additionalQuantityNeeded > 0) {
                            offerMessageHtml = '<div class="multi-buy-message">' +
                                '<div class="multi-buy-message-inner">This offer is ' + offer.tag.split('_')[1] + '</div>' +
                                '<button class="add-remaining" data-id="' + item.id + '" data-additional-quantity="' + additionalQuantityNeeded + '">+</button>' +
                                '</div>';
                        }
                    }
                }

                let imageHtml = item.image ?
                    `<figure class="cart-item--image-wrapper"><a href="${item.url}"><img src="${item.image}" alt="${item.title}" style="max-width:75px; max-height:75px;"></a></figure>` :
                    `<figure class="cart-item--image-wrapper"><a href="${item.url}"><img src="/path/to/placeholder-image.svg" alt="Placeholder Image" style="max-width:75px; max-height:75px;"></a></figure>`;

                let discountListHtml = '';
                let hasDiscounts = item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0;
                if (hasDiscounts) {
                    discountListHtml += '<ul class="discount-list">';
                    item.line_level_discount_allocations.forEach(function(discount) {
                        discountListHtml += `<li class="discount-list-item">${discount.discount_application.title}</li>`;
                    });
                    discountListHtml += '</ul>';
                    offerMessageHtml = '';
                }

                let compareAtPrice = item.compare_at_price || 0;
                let discountedPrice = hasDiscounts ? item.final_price : item.price;

                let priceHtml = 
                    `<div class="price-container">` +
                        (compareAtPrice > item.price || (hasDiscounts && item.original_price > discountedPrice) ?
                            `<s class="cart-item--sale-price money">${Shopify.formatMoney(hasDiscounts ? item.original_price : compareAtPrice, moneyFormat)}</s>` :
                            '') +
                        `<span class="${compareAtPrice > item.price || (hasDiscounts && item.original_price > discountedPrice) ? 'money special-price' : 'money'}">${Shopify.formatMoney(discountedPrice, moneyFormat)}</span>` +
                    `</div>`;

                let isAtMax = item.quantity >= maxQuantity;
                let plusButtonClass = isAtMax ? 'quantity-increase disabled' : 'quantity-increase';

                let quantitySelectorHtml =
                    `<div class="quantity-selector">` +
                        `<button class="quantity-decrease" data-id="${item.id}">-</button>` +
                        `<span class="quantity">${item.quantity}</span>` +
                        `<button class="${plusButtonClass}" data-id="${item.id}">+</button>` +
                    `</div>`;

                let removeButtonHtml = 
                    `<button class="cart-item-remove" data-id="${item.id}" aria-label="Remove item">` +
                        `<img src="${window.trashCanIconUrl}" alt="Remove">` +
                    `</button>`;

                let actionsHtml = 
                    `<div class="cart-item--actions">` +
                        quantitySelectorHtml +
                        removeButtonHtml +
                    `</div>`;

                let textContentHtml = 
                    `<div class="cart-item--text-content">` +
                        `<h2 class="cart-item--content-title">${item.title}</h2>` +
                        priceHtml +
                        discountListHtml +
                        offerMessageHtml +
                        actionsHtml +
                    `</div>`;

                if (item.title.toLowerCase().includes('salt') && !shouldShowSaltUpsell) {
                    shouldShowSaltUpsell = true;
                }

                if (item.title.includes('Kit') && !item.title.includes('Prefilled') && !shouldShowKitUpsell) {
                    shouldShowKitUpsell = true;

                    let compatibleHandles = getCompatibleHandles(item.title);
                    if (compatibleHandles.length > 0) {
                        kitCompatibleHandles = kitCompatibleHandles.concat(compatibleHandles);
                    }
                }

                drawerContent += `<div class="cart-item" data-cartitem-id="${item.id}" data-product-tags="${tags}" data-product-name="${item.title}" data-max-quantity="${maxQuantity}">${imageHtml}${textContentHtml}</div>`;
            });

            kitCompatibleHandles = [...new Set(kitCompatibleHandles)];

            let saltUpsellProducts = [
                'vaporesso-xros-corex-replacement-pods',
                'vaporesso-xros-replacement-pods',
                'oxva-xlim-v3-pods',
                'oxva-xlim-v2-refillable-pods',
                'vaporesso-luxe-x-corex-pods',
                'voopoo-vinci-replacement-pods',
                'oxva-nexlim-replacement-pods',
                'voopoo-argus-top-fill-v2-pods',
                'geekvape-q-replacement-pod-cartridges',
                'aspire-gotek-mesh-coil-replacement-pods'
            ];

            if (shouldShowSaltUpsell) {
                let availableSaltUpsells = saltUpsellProducts.filter(productHandle => {
                    return !cart.items.some(cartItem => cartItem.handle === productHandle);
                });

                if (availableSaltUpsells.length === 0) {
                    shouldShowSaltUpsell = false;
                }
            }

            if (shouldShowKitUpsell && kitCompatibleHandles.length > 0) {
                let availableKitUpsells = kitCompatibleHandles.filter(productHandle => {
                    return !cart.items.some(cartItem => cartItem.handle === productHandle);
                });

                if (availableKitUpsells.length === 0) {
                    shouldShowKitUpsell = false;
                } else {
                    kitCompatibleHandles = availableKitUpsells;
                }
            }

            if (shouldShowKitUpsell && kitCompatibleHandles.length > 0) {
                let upsellProductsHtml = '';
                kitCompatibleHandles.slice(0, 10).forEach(function(productHandle) {
                    upsellProductsHtml += `<div class="upsell-product" data-product-handle="${productHandle}">
                        <div class="upsell-loading">Loading recommendation...</div>
                    </div>`;
                });

                upsellHtml = `<div class="upsell-section" data-upsell-type="kit">
<div class="upsell-header">
    <p id="upsell-title-el">Add compatible pods and coils to your order and get 10% off</p>
</div>
<div class="upsell-container">
    ${upsellProductsHtml}
</div>
</div>`;
            } else if (shouldShowSaltUpsell) {
                let availableSaltUpsells = saltUpsellProducts.filter(productHandle => {
                    return !cart.items.some(cartItem => cartItem.handle === productHandle);
                });

                if (availableSaltUpsells.length > 0) {
                    let upsellProductsHtml = '';
                    availableSaltUpsells.forEach(function(productHandle) {
                        upsellProductsHtml += `<div class="upsell-product" data-product-handle="${productHandle}">
                            <div class="upsell-loading">Loading recommendation...</div>
                        </div>`;
                    });

                    upsellHtml = `<div class="upsell-section" data-upsell-type="salt">
<div class="upsell-header">
    <p id="upsell-title-el">Add your favourite vape pods to your order and get 10% off</p>
</div>
<div class="upsell-container">
    ${upsellProductsHtml}
</div>
</div>`;
                }
            }

            $('.cart-items').html(drawerContent + upsellHtml);
            $('.atc-subtotal--price.money').html(Shopify.formatMoney(cart.total_price, moneyFormat));

            loadUpsellProducts();
            attachEventHandlers();
        });
    });
}

function getCompatibleHandles(productTitle) {
    let handles = [];

    if (productTitle.includes("Innokin Endura T18E Vape Starter Kit")) {
        handles = ["innokin-prism-t18e-coils"];
    } else if (productTitle.includes("Smok Vape Pen V2 Starter Kit")) {
        handles = ["smok-vape-pen-22-coils"];
    } else if (productTitle.includes("Innokin Endura T22E Vape Starter Kit")) {
        handles = ["innokin-prism-t18e-coils"];
    } else if (productTitle.includes("Vaporesso Xros 3 Nano Pod Kit")) {
        handles = ["vaporesso-xros-replacement-pods"];
    } else if (productTitle.includes("Vaporesso Xros 3 Mini Vape Kit")) {
        handles = ["vaporesso-xros-replacement-pods"];
    } else if (productTitle.includes("Vaporesso Xros 3 Refillable Vape Kit")) {
        handles = ["vaporesso-xros-replacement-pods"];
    } else if (productTitle.includes("Vaporesso Xros 4 Mini Pod Kit") || productTitle.includes("Vaporesso Xros 4 Nano Pod Kit") || productTitle.includes("Vaporesso Xros 4 Refillable Vape Kit") || productTitle.includes("Vaporesso Xros Pro Kit")) {
        handles = ["vaporesso-xros-replacement-pods", "vaporesso-xros-corex-replacement-pods"];
    } else if (productTitle.includes("VAPORESSO XROS 2 Vape Kit") || productTitle.includes("Vaporesso XROS Mini Pod Vape Kit") || productTitle.includes("Vaporesso XROS Nano Pod Vape Kit") || productTitle.includes("Vaporesso Xros Cube Vape Kit")) {
        handles = ["vaporesso-xros-replacement-pods"];
    } else if (productTitle.includes("Aspire PockeX Refillable Vape Starter Kit")) {
        handles = ["aspire-pockex-coils-0-6-ohms"];
    } else if (productTitle.includes("VooPoo Drag 3 TPP-X Pod Kit") || productTitle.includes("VooPoo Drag X Pro Pod Vape Kit") || productTitle.includes("VooPoo Drag S Pro Pod Vape Kit") || productTitle.includes("VooPoo Argus MT Vape Kit") || productTitle.includes("Voopoo Argus GT II Vape Kit") || productTitle.includes("VooPoo Argus XT Vape Kit") || productTitle.includes("VooPoo Drag X Plus Pod Kit")) {
        handles = ["voopoo-tpp-coils"];
    } else if (productTitle.includes("GeekVape Obelisk 60 Pod Vape Kit")) {
        handles = ["geekvape-p-series-coils"];
    } else if (productTitle.includes("Voopoo Argus Pro Pod Vape Kit") || productTitle.includes("VooPoo Drag H40 Vape Kit") || productTitle.includes("VooPoo Drag X Pod Vape Kit") || productTitle.includes("VooPoo Drag S Vape Pod Kit") || productTitle.includes("VooPoo Drag H80S Vape Kit") || productTitle.includes("VooPoo Drag E60 Vape Kit") || productTitle.includes("Voopoo Argus Pro 2 Pod Kit")) {
        handles = ["voopoo-pnp-replacement-coils"];
    } else if (productTitle.includes("SMOK RPM 2 Vape Kit") || productTitle.includes("SMOK IPX 80 Pod Vape Kit") || productTitle.includes("Smok Scar P5 Pod Vape Kit") || productTitle.includes("SMOK RPM C Vape Pod Kit") || productTitle.includes("SMOK Nord C Pod Vape Kit")) {
        handles = ["smok-rpm-2-replacement-coils"];
    } else if (productTitle.includes("VooPoo Argus Pod Kit") || productTitle.includes("VooPoo Argus Z Pod Vape Kit") || productTitle.includes("VooPoo Argus Pod SE Vape Kit") || productTitle.includes("VooPoo Argus G Pod Kit") || productTitle.includes("VooPoo Argus P1S Pod Vape Kit") || productTitle.includes("VooPoo Argus A Pod Kit") || productTitle.includes("VooPoo Argus G2 Mini Pod Kit")) {
        handles = ["voopoo-argus-pod-kit-replacement-pods"];
    } else if (productTitle.includes("SMOK Novo 2 Refillable Vape Pod Kit")) {
        handles = ["smok-novo-2-refillable-vape-pods"];
    } else if (productTitle.includes("GeekVape Wenax Q Pod Vape Kit") || productTitle.includes("GeekVape Wenax Q Mini Pod Vape Kit") || productTitle.includes("GeekVape Digi Q Pod Vape Kit")) {
        handles = ["geekvape-q-replacement-pod-cartridges"];
    } else if (productTitle.includes("VooPoo Vinci Pod Vape Kit Royal Edition") || productTitle.includes("VooPoo Vinci Pod Kit") || productTitle.includes("VooPoo Vinci 3 Pod Kit")) {
        handles = ["voopoo-vinci-replacement-pods"];
    } else if (productTitle.includes("VooPoo Vinci SE Pod Kit")) {
        handles = ["voopoo-vinci-v2-replacement-pods"];
    } else if (productTitle.includes("GeekVape G18 Starter Vape Kit")) {
        handles = ["geekvape-g-coils"];
    } else if (productTitle.includes("Uwell Caliburn G Vape Pod Kit") || productTitle.includes("Uwell Caliburn Tenet Refillable Vape Kit") || productTitle.includes("Uwell Caliburn Explorer Pod Vape Kit")) {
        handles = ["uwell-caliburn-g-coils-4-pack", "uwell-caliburn-g-coils"];
    } else if (productTitle.includes("Uwell Caliburn G2 Pod Vape Kit") || productTitle.includes("Uwell Caliburn GK2 Refillable Vape Pod Kit") || productTitle.includes("Uwell Caliburn GK2 Vision Pod Kit") || productTitle.includes("Uwell Caliburn GZ2 Pod Kit")) {
        handles = ["uwell-caliburn-g2-replacement-pods", "uwell-caliburn-g-coils"];
    } else if (productTitle.includes("Uwell Caliburn A2S Refillable Vape Starter Kit")) {
        handles = ["uwell-caliburn-a2s-replacement-pods"];
    } else if (productTitle.includes("Uwell Caliburn A2 Pod Vape Kit") || productTitle.includes("Uwell Caliburn AK2 Pod Kit")) {
        handles = ["uwell-caliburn-a2-pods"];
    } else if (productTitle.includes("Uwell Caliburn G3 Lite Pod Kit") || productTitle.includes("Uwell Caliburn G3 Pod Vape Kit") || productTitle.includes("Uwell Caliburn GK3 Pod Kit") || productTitle.includes("Uwell Caliburn GK3 Tenet Pod Vape Kit") || productTitle.includes("Uwell Caliburn G3 Pro Pod Kit") || productTitle.includes("Uwell Caliburn G4 Pod Kit") || productTitle.includes("Uwell Caliburn G4 Mini Pod Kit")) {
        handles = ["uwell-caliburn-g3-replacement-pods"];
    } else if (productTitle.includes("OXVA Origin 2 Pod Vape Kit")) {
        handles = ["oxva-unicoils-replacement-coils-3-pack"];
    } else if (productTitle.includes("OXVA Xlim C Refillable Vape Kit")) {
        handles = ["xlim-c-replacement-coils-by-oxva-5-pack"];
    } else if (productTitle.includes("OXVA Xlim SQ Pod Vape Kit")) {
        handles = ["oxva-xlim-c-replacement-pods"];
    } else if (productTitle.includes("OXVA Xlim SE Bonus Pod Vape Kit") || productTitle.includes("OXVA Xlim SQ Pro Pod Refillable Vape Kit")) {
        handles = ["oxva-xlim-v2-refillable-pods"];
    } else if (productTitle.includes("Vaporesso Luxe XR Pod Vape Kit") || productTitle.includes("Vaporesso Luxe X Pod Vape Kit") || productTitle.includes("Vaporesso Luxe X Pro Pod Vape Kit")) {
        handles = ["vaporesso-luxe-x-replacement-pods"];
    } else if (productTitle.includes("VooPoo Vthru Pro Pod Kit")) {
        handles = ["voopoo-vthru-replacement-pods"];
    } else if (productTitle.includes("VooPoo VMATE E Pod Kit") || productTitle.includes("VooPoo Vmate Pro Pod Kit")) {
        handles = ["voopoo-vmate-v2-replacement-pods-2-pack"];
    } else if (productTitle.includes("SMOK RPM4 Refillable Vape Pod Kit")) {
        handles = ["smok-rpm40-coils"];
    } else if (productTitle.includes("SMOK Nord Pro Pod Vape Kit")) {
        handles = ["smok-nord-pro-coils"];
    } else if (productTitle.includes("SMOK RPM 5 Pro Vape Kit") || productTitle.includes("SMOK RPM 5 Pod Vape Kit") || productTitle.includes("SMOK RPM 85 Pod Vape Kit") || productTitle.includes("SMOK Nord 5 Pod Vape Kit") || productTitle.includes("SMOK Nord GT Pod Kit")) {
        handles = ["smok-rpm-3-coils"];
    } else if (productTitle.includes("GeekVape Aegis Solo 2 S100 Kit") || productTitle.includes("GeekVape Z200 Vape Kit") || productTitle.includes("GeekVape Aegis X Zeus Kit") || productTitle.includes("GeekVape Aegis Max100 Vape Kit") || productTitle.includes("GeekVape Obelisk 200w Vape Kit") || productTitle.includes("Geekvape L200 Aegis Legend 2 Vape Kit")) {
        handles = ["geekvape-zues-replacement-coils"];
    } else if (productTitle.includes("Smok Nord 4 Pod Vape Kit")) {
        handles = ["smok-rpm-40-replacement-coils", "smok-rpm-2-replacement-coils"];
    } else if (productTitle.includes("VooPoo Drag X PnP-X Pod Vape Kit")) {
        handles = ["voopoo-pnp-x-replacement-coils", "voopoo-pnp-x-replacement-pod"];
    } else if (productTitle.includes("VooPoo Drag S2 Pod Vape Kit") || productTitle.includes("VooPoo Drag X2 Pod Vape Kit") || productTitle.includes("VooPoo Drag 5 Vape Kit") || productTitle.includes("VooPoo Vinci Spark 100 Vape Kit") || productTitle.includes("VooPoo Vinci E120 Pod Kit")) {
        handles = ["voopoo-pnp-x-replacement-coils"];
    } else if (productTitle.includes("Innokin Endura T22 Pro Vape Kit") || productTitle.includes("Innokin Endura T18 X Kit")) {
        handles = ["innokin-prism-t18e-coils"];
    } else if (productTitle.includes("Aspire Zelos 3 Vape Kit")) {
        handles = ["aspire-nautilus-2s-coils"];
    } else if (productTitle.includes("OXVA Xlim Pro Pod Vape Kit") || productTitle.includes("OXVA Xlim Pod Vape Kit") || productTitle.includes("Oxva Xlim Go Pod Kit") || productTitle.includes("OXVA Xlim SQ Pro 2 Pod Kit") || productTitle.includes("OXVA Xlim Pro 2 Pod Vape Kit")) {
        handles = ["oxva-xlim-v3-pods"];
    } else if (productTitle.includes("SMOK Stick N18 Vape Kit")) {
        handles = ["smok-nord-mesh-coils"];
    } else if (productTitle.includes("GeekVape H45 Hero 2 Pod Vape Kit") || productTitle.includes("GeekVape B60 (Aegis Boost 2) Pod Vape Kit") || productTitle.includes("GeekVape M100 Aegis Mini 2 Vape Kit") || productTitle.includes("GeekVape H45 Classic Pod Kit")) {
        handles = ["geekvape-aegis-boost-replacement-coils", "geekvape-aegis-boost-replacement-pods"];
    } else if (productTitle.includes("SMOK ProPod Pod Vape Kit") || productTitle.includes("SMOK Nord 50w Pod Vape Kit")) {
        handles = ["smok-lp2-coils"];
    } else if (productTitle.includes("Uwell Caliburn AK3 Refillable Vape Starter Kit") || productTitle.includes("Uwell Caliburn A3 Vape Kit") || productTitle.includes("Uwell Caliburn AZ3 Pod Kit")) {
        handles = ["uwell-caliburn-a3-replacement-pods-1"];
    } else if (productTitle.includes("Caliburn A3S Vape Kit") || productTitle.includes("Uwell Caliburn AZ3 Pod Kit")) {
        handles = ["uwell-caliburn-a3s-replacement-pods"];
    } else if (productTitle.includes("Geekvape Aegis 1FC Pod Vape Kit")) {
        handles = ["geekvape-one-pod-refillable-pods-pack-of-3"];
    } else if (productTitle.includes("Voopoo Argus P1 Pod Vape Kit") || productTitle.includes("VooPoo Drag Q Pod Vape Kit") || productTitle.includes("VooPoo Argus G2 Pod Kit") || productTitle.includes("VooPoo Argus P2 Pod Kit") || productTitle.includes("VooPoo Argus E40 Pod Vape Kit")) {
        handles = ["voopoo-ito-replacement-coils"];
    } else if (productTitle.includes("Voopoo Drag Nano 2 Pod Vape Kit")) {
        handles = ["voopoo-drag-nano-2-replacement-pods"];
    } else if (productTitle.includes("Vaporesso Luxe Q Pod Kit") || productTitle.includes("Vaporesso Luxe QS Pod Vape Kit") || productTitle.includes("Vaporesso Luxe Q2 SE Pod Kit")) {
        handles = ["vaporesso-luxe-q-pods"];
    } else if (productTitle.includes("Uwell Caliburn Koko Prime Pod Kit")) {
        handles = ["uwell-caliburn-g-coils"];
    } else if (productTitle.includes("Innokin Endura T20-S Vape Starter Kit")) {
        handles = ["innokin-t20s-prism-s-coils"];
    } else if (productTitle.includes("SMOK RPM 40 Refillable Vape Pod Kit") || productTitle.includes("SMOK Scar P3 Pod Kit")) {
        handles = ["smok-rpm-40-replacement-coils"];
    } else if (productTitle.includes("SMOK Novo 4 Mini Pod Vape Kit")) {
        handles = ["smok-lp1-coils"];
    } else if (productTitle.includes("Uwell Caliburn X Vape Kit")) {
        handles = ["uwell-caliburn-x-replacement-pods"];
    } else if (productTitle.includes("Innokin Adept Zlide Vape Kit") || productTitle.includes("Innokin Coolfire Z60 Vape Kit") || productTitle.includes("Innokin GOZEE Vape Kit")) {
        handles = ["innokin-zenith-replacement-coils"];
    } else if (productTitle.includes("SMOK Species V2 230W Vape Kit") || productTitle.includes("SMOK Morph 219 Vape Kita")) {
        handles = ["smok-tfv-mini-v2-vape-coils-baby-v2"];
    } else if (productTitle.includes("SMOK Stick Prince P25 Vape Kit")) {
        handles = ["smok-tfv12-prince-coils"];
    } else if (productTitle.includes("Aspire Gotek S Pod Kit")) {
        handles = ["aspire-gotek-mesh-coil-replacement-pods"];
    } else if (productTitle.includes("OXVA Oneo Pod Vape Kit")) {
        handles = ["oxva-oneo-replacement-pods"];
    } else if (productTitle.includes("Vaporesso Eco Nano Vape Pod Kit")) {
        handles = ["vaporesso-eco-nano-refillable-pods"];
    } else if (productTitle.includes("Vaporesso Luxe Q2 Pod Kit")) {
        handles = ["vaporesso-xros-replacement-pods"];
    }

    return handles;
}

function loadUpsellProducts() {
    let loadedCount = 0;
    let totalProducts = $('.upsell-product').length;

    if (totalProducts === 0) {
        return;
    }

    $('.upsell-product').each(function() {
        let $upsellContainer = $(this);
        let productHandle = $upsellContainer.data('product-handle');

        if (productHandle) {
            $.getJSON('/products/' + productHandle + '.js', function(product) {
                let moneyFormat = window.ShopifyMoneyFormat || '$';

                let variantOptionsHtml = '';
                product.variants.forEach(function(variant) {
                    if (variant.available) {
                        let variantTitle = variant.title !== 'Default Title' ? variant.title : 'Standard';
                        let variantPrice = Shopify.formatMoney(variant.price, moneyFormat);
                        variantOptionsHtml += `<option value="${variant.id}" data-price="${variant.price}">${variantTitle} - ${variantPrice}</option>`;
                    }
                });

                let defaultVariant = product.variants.find(v => v.available) || product.variants[0];
                let originalPrice = defaultVariant.price;
                let discountedPrice = Math.round(originalPrice * 0.9);

                let upsellProductHtml = `
                    <div class="upsell-item">
                        <span class="upsell-discount-label">Save 10%</span>
                        <div class="upsell-image">
                            <img src="${product.featured_image}" alt="${product.title}">
                        </div>
                        <div class="upsell-details">
                            <h5 class="upsell-title">${product.title}</h5>
                            <div class="upsell-price-container">
                                <s class="upsell-original-price">${Shopify.formatMoney(originalPrice, moneyFormat)}</s>
                                <span class="upsell-discounted-price">${Shopify.formatMoney(discountedPrice, moneyFormat)}</span>
                            </div>
                            ${product.variants.length > 1 ? `
                                <div class="upsell-variant-selector">
                                    <select class="upsell-variant-select" data-product-id="${product.id}" style="width: 100%; margin: 5px 0; padding: 5px; border: 1px solid #ccc; border-radius: 4px;">
                                        ${variantOptionsHtml}
                                    </select>
                                </div>
                            ` : ''}
                        </div>
                        <button class="upsell-add-btn" data-variant-id="${defaultVariant.id}" data-product-id="${product.id}">
                            Add
                        </button>
                    </div>
                `;

                $upsellContainer.html(upsellProductHtml);

                loadedCount++;

                if (loadedCount === totalProducts) {
                    setTimeout(addUpsellScrollArrows, 200);
                }

            }).fail(function() {
                $upsellContainer.html('<div class="upsell-error">Product not available</div>');
                loadedCount++;

                if (loadedCount === totalProducts) {
                    setTimeout(addUpsellScrollArrows, 200);
                }
            });
        } else {
            loadedCount++;
            if (loadedCount === totalProducts) {
                setTimeout(addUpsellScrollArrows, 200);
            }
        }
    });
}

function addUpsellScrollArrows() {

    $('.upsell-container').each(function() {
        let $container = $(this);

        if ($container.parent().hasClass('upsell-container-wrapper')) {
            return;
        }

        $container.wrap('<div class="upsell-container-wrapper"></div>');
        let $wrapper = $container.parent('.upsell-container-wrapper');

        $wrapper.append(`
            <button class="upsell-scroll-arrow upsell-scroll-left">‹</button>
            <button class="upsell-scroll-arrow upsell-scroll-right">›</button>
        `);

        $wrapper.find('.upsell-scroll-left').on('click', function(e) {
            e.preventDefault();
            $container.animate({ scrollLeft: '-=400px' }, 300);
        });

        $wrapper.find('.upsell-scroll-right').on('click', function(e) {
            e.preventDefault();
            $container.animate({ scrollLeft: '+=400px' }, 300);
        });

        function updateArrowVisibility() {
            let scrollLeft = $container.scrollLeft();
            let scrollWidth = $container[0].scrollWidth;
            let containerWidth = $container.outerWidth();

            $wrapper.find('.upsell-scroll-left').toggle(scrollLeft > 0);
            $wrapper.find('.upsell-scroll-right').toggle(scrollLeft < scrollWidth - containerWidth - 1);
        }

        $container.on('scroll', updateArrowVisibility);
        setTimeout(updateArrowVisibility, 300);
    });
}

function applyDiscountCode(discountCode) {
    return new Promise(function(resolve, reject) {

        fetch('/discount/' + discountCode, {
            method: 'GET',
            credentials: 'same-origin'
        }).then(function(response) {
            if (response.ok) {
                resolve(true);
            } else {
                reject(false);
            }
        }).catch(function(error) {
            console.error('Error applying discount:', error);
            reject(false);
        });
    });
}

function updateDeliveryProgressBar(subtotal) {
    var freeShippingThreshold = 25;
    var progressPercentage = Math.min(subtotal / freeShippingThreshold * 100, 100);

    if (progressPercentage > 95 && progressPercentage < 100) {
        progressPercentage = 95;
    } else {
        progressPercentage = Math.min(progressPercentage, 100);
    }

    var color;
    if (progressPercentage < 100) {

        var redToOrangeProgress = Math.min(progressPercentage, 100);
        var red = 255;
        var green = Math.round(30 + (175 * redToOrangeProgress / 100)); 

        var blue = 0;
        color = 'rgb(' + red + ',' + green + ',' + blue + ')';
    } else {

        color = '#41a97a'; 

    }

    $('#delivery-progress-bar').css({
        'width': progressPercentage + '%',
        'background-color': color
    });

    var message;
    if (subtotal >= freeShippingThreshold) {
        message = 'You have qualified for free shipping';
    } else {
        var amountRemaining = (freeShippingThreshold - subtotal).toFixed(2);
        message = 'You are £' + amountRemaining + ' away from free shipping';
    }

    $('#delivery-progress-message').text(message);
}

   function attachEventHandlers() {
    $('.quantity-decrease, .quantity-increase').off('click').on('click', function() {
        let itemId = $(this).data('id');
        let $cartItem = $(this).closest('.cart-item');

        if ($(this).hasClass('disabled')) {
            return; 

        }

        let $quantityDisplay = $cartItem.find('.quantity');
        let currentQuantity = parseInt($quantityDisplay.text());

        let productTags = $cartItem.data('product-tags') || '';
        productTags = String(productTags).toLowerCase();

        let incrementValue = 1;
        let minQuantity = 1;

        if (productTags.includes('minimum 10')) {
            incrementValue = 10;
            minQuantity = 10;
        } else if (productTags.includes('minimum 5')) {
            incrementValue = 5;
            minQuantity = 5;
        }

        let newQuantity;
        if ($(this).hasClass('quantity-increase')) {
            newQuantity = currentQuantity + incrementValue;

            let maxQuantity = $cartItem.data('max-quantity');

            if (maxQuantity && newQuantity > maxQuantity) {
                return; 

            }
        } else {
            newQuantity = currentQuantity - incrementValue;
        }

        if (newQuantity < minQuantity) return;

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { 
                id: itemId, 
                quantity: newQuantity 
            },
            dataType: 'json',
            success: function(response) {
                updateCartDrawer();
            },
            error: function() {
                alert("Failed to update item quantity.");
            }
        });
    });

      $('.cart-item-remove').off('click').on('click', function() {
            let itemId = $(this).data('id');

            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: { 
                    id: itemId, 
                    quantity: 0 
                },
                dataType: 'json',
                success: function(response) {
                    updateCartDrawer();
                },
                error: function() {
                    alert("Failed to remove item from cart.");
                }
            });
        });

        $('.add-remaining').off('click').on('click', function() {
        let itemId = $(this).data('id');
        let additionalQuantity = $(this).data('additional-quantity');

        let currentQuantity = parseInt($(`.cart-item[data-cartitem-id="${itemId}"] .quantity`).text());

        let newTotalQuantity = currentQuantity + additionalQuantity;

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { 
                id: itemId, 
                quantity: newTotalQuantity 
            },
            dataType: 'json',
            success: function(response) {
                updateCartDrawer();
            },
            error: function() {
                alert("Failed to update item quantity.");
            }
        });
    });

    $(document).off('click', '.upsell-add-btn').on('click', '.upsell-add-btn', function() {
        let $button = $(this);
        let $upsellItem = $button.closest('.upsell-item');
        let $variantSelect = $upsellItem.find('.upsell-variant-select');

        let variantId;
        if ($variantSelect.length > 0) {
            variantId = $variantSelect.val();
        } else {
            variantId = $button.data('variant-id');
        }

        $button.prop('disabled', true).text('Adding');

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: 1
            },
            dataType: 'json',
            success: function(response) {

                applyDiscountCode('10%2525%2520OFF').then(function() {
                    updateCartDrawer(); 

                }).catch(function() {
                    updateCartDrawer(); 

                });
            },
            error: function(xhr, status, error) {
                alert("Failed to add upsell item to cart.");
                $button.prop('disabled', false).text('Add');
            }
        });
    });

    $(document).off('change', '.upsell-variant-select').on('change', '.upsell-variant-select', function() {
        let selectedVariantId = $(this).val();
        let $addButton = $(this).closest('.upsell-details').find('.upsell-add-btn');
        let $priceContainer = $(this).closest('.upsell-details').find('.upsell-price-container');

        $addButton.data('variant-id', selectedVariantId);
        $addButton.attr('data-variant-id', selectedVariantId);

        let selectedPrice = parseInt($(this).find('option:selected').data('price'));
        let discountedPrice = Math.round(selectedPrice * 0.9); 

        let moneyFormat = window.ShopifyMoneyFormat || '$';

        $priceContainer.find('.upsell-original-price').text(Shopify.formatMoney(selectedPrice, moneyFormat));
        $priceContainer.find('.upsell-discounted-price').text(Shopify.formatMoney(discountedPrice, moneyFormat));

    });
}

    updateCartDrawer();
});